import React from "react";

const MailRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 6C3 4.89543 3.89543 4 5 4L15.5 4C16.6046 4 17.5 4.89543 17.5 6V14.5C17.5 15.6046 16.6046 16.5 15.5 16.5H5C3.89543 16.5 3 15.6046 3 14.5L3 6Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.75 4.75L10.25 10.5L16.75 4.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MailRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;